<template>
    <div>
        <div>
            <Form
                :model="formData"
                ref="recount"
                :label-width="60"
                :rules="ruleValidate"
            >
                <FormItem
                    :label="$t('fbb.bill.customer', { defaultValue: '客户' })"
                    prop="orgId"
                >
                    <Select
                        v-model="formData.orgId"
                        style="width: 300px"
                        @on-change="getPaymentDays"
                    >
                        <Option
                            v-for="item in getNextOrgList"
                            :value="item.value"
                            :key="item.value"
                        >
                            {{ item.label }}
                        </Option>
                    </Select>
                </FormItem>
                <FormItem
                    :label="
                        $t('fbb.bill.account_period', { defaultValue: '账期' })
                    "
                    prop="periodId"
                >
                    <Select
                        v-model="formData.periodId"
                        style="width: 300px"
                        @on-change="getBillNumber"
                    >
                        <Option
                            v-for="item in paymentDays"
                            :value="item.id"
                            :key="item.id"
                        >
                            {{ item.code }}
                        </Option>
                    </Select>
                </FormItem>
                <FormItem
                    :label="
                        $t('fbb.bill.account_period_number', {
                            defaultValue: '账期编号',
                        })
                    "
                >
                    <label style="font-weight: bolder">{{
                        formData.billNo
                    }}</label>
                </FormItem>
            </Form>
        </div>
        <div class="text-right">
            <vButton theme="primary" @click="submit">{{
                $t("global.common.save", { defaultValue: "保存" })
            }}</vButton>
            <vButton class="margin-left-10" @click="cancel">{{
                $t("global.common.return", { defaultValue: "返回" })
            }}</vButton>
        </div>
        <Spin size="large" fix v-if="loading"></Spin>
    </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
import {
    HttpGetPaymentDays,
    HttpGetBillNumber,
    HttpRecountSave,
} from "@/service/fedex";
export default {
    components: {},
    data() {
        return {
            contextId: global.SYSID,
            loading: false,
            formData: {
                orgId: "",
                periodId: "",
                billNo: "", //账单编号
                billId: "",
            },
            paymentDays: [], //账期
            ruleValidate: {
                orgId: [
                    {
                        required: true,
                        message: this.$t("fbb.bill.fill_in", {
                            defaultValue: "该信息不能为空,请填写",
                        }),
                    },
                ],
                periodId: [
                    {
                        required: true,
                        message: this.$t("fbb.bill.fill_in", {
                            defaultValue: "该信息不能为空,请填写",
                        }),
                    },
                ],
            },
        };
    },
    created() {},
    computed: {
        ...mapGetters("dictionary", ["getNextOrgList"]),
    },
    methods: {
        getPaymentDays(value) {
            HttpGetPaymentDays({
                orgId: this.formData.orgId,
            }).then((res) => {
                this.paymentDays = res.data;
                this.formData.periodId = res.data[0].id;
                this.getBillNumber();
            });
        },
        getBillNumber() {
            HttpGetBillNumber({
                periodId: this.formData.periodId,
            }).then((res) => {
                this.formData.billNo = res.data.billNo;
                this.formData.billId = res.data.id;
            });
        },
        submit() {
            this.$refs["recount"].validate((valid) => {
                if (!valid) return;
                this.loading = true;
                HttpRecountSave({
                    billId: this.formData.billId,
                })
                    .then((res) => {
                        this.$VMessage.success(res.message);
                        this.loading = false;
                        this.cancel();
                    })
                    .catch((err) => {
                        this.$VMessage.error(err.message);
                        this.loading = false;
                    });
            });
        },
        cancel() {
            this.$emit("on-close");
        },
    },
};
</script>
